import React from 'react';

import { Tooltip } from 'antd';
import { SafetyOutlined } from '@ant-design/icons';
import classnames from 'classnames';

const GdsnShieldIcon = (props) => {
  const { gdsnShield, subscriptionShield } = props;

  const gdsnShieldColour = (gdsnShield || '').toLowerCase();
  const subscriptionShieldStatus = (subscriptionShield || '').toLowerCase();

  // Hide the GDSN shield when the product is received from GDSN (green) and it
  // is already subscribed/syndicated — the subscription shield represents it.
  const hideGdsnShield =
    gdsnShieldColour === 'green' &&
    (subscriptionShieldStatus === 'subscribed' ||
      subscriptionShieldStatus === 'syndicated');

  if (hideGdsnShield) return null;

  const showSafetyShield = () => {
    let tooltipContent = 'Subscribed Product';
    if (gdsnShieldColour === 'yellow')
      tooltipContent = 'Received from GDSN, and modified';
    if (gdsnShieldColour === 'green') tooltipContent = 'Received from GDSN';
    return (
      <Tooltip title={tooltipContent} placement='top'>
        <SafetyOutlined
          className={classnames({
            'thumbnail-item__gdsn-shield': true,
            'thumbnail-item__gdsn-shield--yellow':
              gdsnShieldColour === 'yellow',
            'thumbnail-item__gdsn-shield--green': gdsnShieldColour === 'green',
          })}
        />
      </Tooltip>
    );
  };

  return <>{showSafetyShield()}</>;
};

export default GdsnShieldIcon;
